<template>
  <div class="modal fade" :id="modalId" tabindex="-1" role="dialog" aria-hidden="true" :ref="modalId">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header text-left">
          <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>
          <h4 class="modal-title">
            {{modalState}}
          </h4>
        </div>
        <div class="modal-body" v-if="!combineInfo.length && state != 1">
          <div class="text-red">
            請新增此商品的組合&nbsp;&nbsp;•ᴥ•
          </div>
        </div>
        <div class="modal-body">
          <ul class="nav nav-tabs" style="margin-bottom: 10px;" v-if="state != 1 && combineInfo.length">
            <li role="presentation" v-for="(combine, index) in combineInfo" :class="{active: isTabActive(index + 1)}">
              <a  @click.prevent="clickCombine(combine, index)">{{combine.name}}
                <span v-if="state == 3 && !editState && combine.is_common">&nbsp;<label class="badge bg-blue">常見</label></span>
              </a>
            </li>
            <li class="pull-right" v-if="pageAmount > 1">
              <ul class="pagination" style="margin: 0px">
                <li class="paginate_button" v-for="index in pageAmount" :class="{active: isActive(index)}" @click="getCombineInfo(index)">
                  <a class="c-pointer">{{index}}</a>
                </li>
              </ul>
            </li>
          </ul>
          <div class="text-right" style="margin-right: 10px;" v-if="combineInfo.length">
            <button class="btn btn-primary icon-modal-edit inherit" v-if="!editState && state == 3" @click.prevent="editState = true"><i class="fa fa-pencil" aria-hidden="true"></i></button>
            <button class="btn btn-primary icon-modal-edit inherit" v-if="editState" @click.prevent="editState = false"><i class="fa fa-eye" aria-hidden="true"></i></button>
          </div>
          <!-- info start-->
          <div class="box-body form form-100-p" v-if="state == 3 && !editState">
            <div class="col-xs-12 text-left p-x-0">
              <div class="col-xs-12" v-for="(a, index) in adjust">
                <div class="text-black col-xs-12 block-adjust-title">
                  <span style="top: 6px;">{{a.name}}&nbsp;<span v-if="getPrice(a.edge_price, a.price)">${{getPrice(a.edge_price, a.price)}}</span></span>
                </div>
                <div class="text-black col-xs-12">
                  <span class="text-15">{{a.description}} <span v-if="a.remark">({{a.remark}})</span></span>
                </div>
                <div class="card-body col-xs-12">
                  <div class="col-xs-6 col-md-3 p-5" v-for="(o, index) in a.option_list">
                    <button class="btn-options text-16">{{o.name}}&nbsp;<span v-if="getPrice(o.edge_price, o.price)">${{getPrice(o.edge_price, o.price)}}</span></button>
                  </div>
                </div>
                <span class="col-xs-12">
                    <br>
                  </span>
              </div>
            </div>
            <div class="col-xs-12 text-left p-x-0" v-if="option.length">
              <div class="col-xs-12">
                <div class="text-black col-xs-12 block-adjust-title">
                  <span style="top: 6px;">其他選項</span>
                </div>
                <div class="card-body col-xs-12">
                  <div class="col-xs-6 col-md-3 p-5" v-for="(o, index) in option">
                    <button class="btn-options text-16">{{o.name}}&nbsp;<span v-if="getPrice(o.edge_price, o.price)">${{getPrice(o.edge_price, o.price)}}</span></button>
                  </div>
                </div>
                <span class="col-xs-12">
                  <br>
                </span>
              </div>
            </div>
          </div>
          <!-- info end-->
          <!-- form start -->
          <div class="box-body form form-100-p" v-if="state == 1 || editState">
            <div v-show="page">
              <div class="col-xs-12 text-left p-x-0">
                <div class="col-xs-12" v-for="(a, index) in adjust">
                  <div class="text-black col-xs-12 block-adjust-title">
                    <span style="top: 6px;">{{a.name}}&nbsp; $ <price-input :price="a" @trigger="trigger" :id="a.adjust_id"></price-input></span>
                  </div>
                  <div class="text-black col-xs-12">
                    <span class="text-15">{{a.description}} <span v-if="a.remark">({{a.remark}})</span></span>
                  </div>
                  <div class="card-body col-xs-12">
                    <div class="col-xs-6 col-md-3 p-5" v-for="(o, index) in a.option_list">
                      <button class="btn-options text-16" :class="{active: o.tag}">
                        <span>{{o.name}}</span><br>
                        $ <price-input :price="o" @trigger="trigger" :id="o.option_id" style="color: #e1456d" :class="{disabled: a.price}"></price-input>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12" v-if="option.length">
                  <div class="text-black col-xs-12 block-adjust-title">
                    <span style="top: 6px;">其他選項</span>
                  </div>
                  <div class="card-body col-xs-12">
                    <div class="col-xs-6 col-md-3 p-5" v-for="(o, index) in option">
                      <button class="btn-options text-16"><span>{{o.name}}</span><br>
                        $ <price-input :price="o" @trigger="trigger" :id="o.option_id" style="color: #e1456d"></price-input>
                      </button>
                    </div>
                  </div>
                  <span class="col-xs-12">
                    <br>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- form end-->
        </div>
        <div class="modal-footer" v-if="state != 3 || editState">
          <button type="button" class="btn btn-default" data-dismiss="modal">返回</button>
          <button type="button" class="btn btn-primary" v-if="editState" @click="checkInputEmpty">編輯</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import $ from 'jquery'
import priceInput from './PriceInput.vue'
export default {
  name: 'CombinePriceModal',
  props: {
    modalId: {
      type: String,
      required: true
    },
    // 1 = add, 2 = edit, 3 = info
    state: {
      type: Number
    },
    productId: {
      type: Number,
      required: true
    },
    productName: {
      type: String
    },
    type: {
      type: String
    }
  },
  components: {
    'price-input': priceInput
  },
  data () {
    return {
      editState: false,
      page: 1,
      tabIndex: 1,
      tableIndex: 1,
      adjustIndex: 1,
      count: 20,
      maxTotal: 0,
      maxAdjustTotal: 0,
      show: {
        delNotify: false
      },
      buff: {},
      optionsAmount: {},
      chooseOptions: {},
      adjustNumList: [],
      changePriceList: {},
      oldAdjust: [],
      oldOption: [],
      adjust: [],
      option: [],
      combineInfo: {},
      combineDetail: {},
      chosen: {
        adjust: [],
        option: []
      }
    }
  },
  methods: {
    ...mapActions(['setUpCategory', 'setModal']),
    trigger (obj) {
      // console.log(obj)
      if (obj.method === 'cancelChange') {
        // console.log(obj)
        this.cancelChange(obj.priceList)
      } else if (obj.method === 'changePrice') {
        this.changePrice(obj.priceList)
      }
    },
    init () {
      if (typeof this.info !== 'undefined') {
        this.brandName = this.info.name
        this.brandType = this.info.type
      }
    },
    toggle () {
      $(this.$refs.infoCategoryModal).css('display')
    },
    getPriceType (type) {
      if (type === 1) return '免稅價格'
      else if (type === 3) return '含稅價格'
    },
    getPrice (edgePrice, price) {
      if (!edgePrice && typeof edgePrice === 'object') {
        return price
      } else if (typeof edgePrice === 'undefined') {
        return price
      } else {
        return edgePrice
      }
    },
    maxAmount (max) {
      if (!max) return '無限制'
      else return max
    },
    getOption (index) {
      return this.option[index]
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    isTabActive (index) {
      if (this.tabIndex === index) return true
      else return false
    },
    isAdjustActive (index) {
      if (this.adjustIndex === index) return true
      else return false
    },
    getCombineInfo (index) {
      var self = this
      if (index) this.tableIndex = index
      var url = 'brand/' + this.$route.params.brand_id + '/product/' + this.productId + '/combinationlist?page=' + this.tableIndex + '&size=' + this.count
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          // console.log(response.data.combination_list)
          self.combineInfo = response.data.combination_list
          self.maxTotal = response.data.meta.total
          if (self.combineInfo.length) {
            self.clickCombine(self.combineInfo[0], 0)
          }
        }
      })
    },
    clickCombine (combine, index) {
      this.oldOption = []
      this.oldAdjust = []
      this.tabIndex = index + 1
      this.getCombineDetail(combine.combine_id)
    },
    getCombineDetail (comId) {
      var self = this
      comId = parseInt(comId, 10)
      var url = 'brand/' + this.$route.params.brand_id + '/combination/' + comId
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.combineDetail = response.data.combination
          self.adjust = self.combineDetail.adjust_list
          self.option = self.combineDetail.option_list
          for (let i = 0; i < self.adjust.length; i++) {
            self.adjustNumList.push(self.adjust[i].adjust_id)
            self.oldAdjust.push({
              adjust_id: self.adjust[i].adjust_id,
              price: self.adjust[i].price
            })
          }
          for (let j = 0; j < self.option.length; j++) {
            self.oldOption.push({
              option_id: self.option[j].option_id,
              price: self.option[j].price
            })
          }
          self.getOptions()
        }
      })
    },
    getOptions () {
      var self = this
      // set to oldOption and oldAdjust
      for (let i = 0; i < self.adjust.length; i++) {
        var aPrice = self.adjust[i].price
        if (self.adjust[i].edge_price) aPrice = self.adjust[i].edge_price
        self.oldAdjust.push({
          adjust_id: self.adjust[i].adjust_id,
          price: aPrice
        })
      }
      for (let j = 0; j < self.option.length; j++) {
        var oPrice = self.option[j].price
        if (self.option[j].edge_price) oPrice = self.option[j].edge_price
        self.oldOption.push({
          adjust_id: self.option[j].option_id,
          price: oPrice
        })
      }
      if (this.adjustNumList.length) {
        for (let i = 0; i < this.adjustNumList.length; i++) {
          this.optionByAId(this.adjustNumList[i])
        }
      }
    },
    optionByAId (adjustId, index) {
      var page = 1
      if (index) page = index
      var self = this
      if (adjustId) {
        var url = 'brand/' + this.$route.params.brand_id + '/adjust/' + adjustId + '/optionlist?page=' + page + '&size=' + this.count
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            var adjustId = response.data.meta.adjust_id
            var oList = response.data.option_list
            self.optionsAmount[adjustId] = oList.length
            for (let i in oList) {
              oList[i]['tag'] = false
            }
            self.oldAdjust.filter(function (elem, index, obj) {
              if (elem.adjust_id === adjustId) {
                self.$set(elem, 'option_old_list', [])
                for (var j in oList) {
                  var oPrice = oList[j].price
                  if (oList[j].edge_price) oPrice = oList[j].edge_price
                  var o = {
                    option_id: oList[j].option_id,
                    price: oPrice
                  }
                  elem.option_old_list.push(o)
                }
              }
            })
            self.adjust.filter(function (elem, index, obj) {
              if (elem.adjust_id === adjustId) {
                self.$set(elem, 'option_list', oList)
              }
            })
            self.stOldAdjust(adjustId, oList)
          }
        })
      }
    },
    stOldAdjust (adjustId, oList) {
      var self = this
      self.oldAdjust.filter(function (elem, index, obj) {
        if (elem.adjust_id === adjustId) {
          self.$set(elem, 'option_old_list', [])
          for (var j in oList) {
            var o = {
              option_id: oList[j].option_id,
              price: oList[j].price
            }
            elem.option_old_list.push(o)
          }
        }
      })
    },
    getAllAdjust (index) {
      var self = this
      if (index) this.adjustIndex = index
      var url = 'brand/' + this.$route.params.brand_id + '/adjust/list?page=' + this.adjustIndex + '&size=' + this.count
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.maxAdjustTotal = response.data.meta.total
          for (let i = 0; i < response.data.adjust_list.length; i++) {
            self.adjust.push(response.data.adjust_list[i])
            self.adjustNumList.push(response.data.adjust_list[i].adjust_id)
            self.chooseOptions[response.data.adjust_list[i].adjust_id] = {
              active_count: 0,
              active_options: []
            }
          }
          if (response.data.adjust_list.length) {
            self.adjustIndex = self.adjustIndex + 1
            self.getAllAdjust(self.adjustIndex)
          } else self.getOptions()
        }
      })
    },
    clearData () {
      this.adjust = []
      this.option = []
      this.adjustNumList = []
      this.oldOption = []
      this.oldAdjust = []
    },
    chooseOption (o, a, allType) {
      // allType = 'all' is all chose, allType = 'remove' is all remove
      var self = this
      // var tag = o.tag
      self.adjust.filter(function (elem, index, obj) {
        if (elem.adjust_id === a.adjust_id) {
          elem.option_list.filter(function (e, i, options) {
            if (e.option_id === o.option_id) {
              if (!o.tag && allType !== 'remove') {
                self.chooseOptions[a.adjust_id]['active_count'] = self.chooseOptions[a.adjust_id]['active_count'] + 1
                self.chooseOptions[a.adjust_id]['active_options'].push(o.option_id)
              } else if (allType === 'all') {
              } else {
                self.chooseOptions[a.adjust_id]['active_count'] = self.chooseOptions[a.adjust_id]['active_count'] - 1
                if (self.chooseOptions[a.adjust_id]['active_options'].length) {
                  let index = self.chooseOptions[a.adjust_id]['active_options'].indexOf(o.option_id)
                  self.chooseOptions[a.adjust_id]['active_options'].splice(index, 1)
                }
                if (self.chooseOptions[a.adjust_id]['active_count'] < 0) self.chooseOptions[a.adjust_id]['active_count'] = 0
              }
              if (allType === 'all') o.tag = true
              else if (allType === 'remove') o.tag = false
              else o.tag = !o.tag
            }
          })
        }
      })
    },
    chooseOptionsByAdjust (a) {
      var self = this
      var optionList = a.option_list
      for (let i in optionList) {
        let o = optionList[i]
        self.chooseOption(o, a, 'all')
      }
    },
    removeOptionsByAdjust (a) {
      var self = this
      var optionList = a.option_list
      for (let i in optionList) {
        let o = optionList[i]
        self.chooseOption(o, a, 'remove')
      }
    },
    cancelChange (priceList) {
      // console.log(this.changePriceList)
      for (var key in this.changePriceList) {
        if (key === Object.keys(priceList)) this.changePriceList.splice(key, 1)
      }
      if (!this.changePriceList.length) this.changePriceList = {}
      // console.log(this.changePriceList)
    },
    changePrice (priceList) {
      // console.log(priceList)
      if (parseInt(Object.values(priceList), 10)) {
        this.changePriceList[Object.keys(priceList)] = parseInt(Object.values(priceList), 10)
      }
      var adjustId = ''
      // console.log(this.adjust)
      var optionList = {}
      for (var i = 0; i < this.adjust.length; i++) {
        if (this.adjust[i].adjust_id === parseInt(Object.keys(priceList), 10)) {
          adjustId = this.adjust[i].adjust_id
          optionList = this.adjust[i].option_list
        }
      }
      // console.log(optionList)
      for (var j = 0; j < optionList.length; j++) {
        for (var key in this.changePriceList) {
          // console.log(key)
          // console.log(optionList[j].option_id)
          if (parseInt(key, 10) === optionList[j].option_id) {
            if (!this.buff[adjustId]) this.buff[adjustId] = {}
            this.buff[adjustId][key] = this.changePriceList[key]
            delete this.changePriceList[key]
          }
        }
      }
      // console.log(this.buff)
      // console.log(optionList)
      // console.log(this.changePriceList)
    },
    checkInputEmpty () {
      this.chosen = {
        adjust: [],
        option: []
      }
      for (var i = 0; i < this.adjust.length; i++) {
        if (this.adjust[i].price !== this.oldAdjust[i].price) {
          // adjust 有修改
          this.chosen.adjust.push(this.adjust[i].adjust_id + '/' + this.adjust[i].price)
        } else {
          var tag = false
          var oList = this.adjust[i].option_list
          var oldOList = this.oldAdjust[i].option_old_list
          // 確認有沒有修改option的價格
          if (oList.length) {
            for (var j = 0; j < oList.length; j++) {
              if (oList[j].price !== oldOList[j].price) {
                tag = true
                break
              }
            }
          }
          if (!tag) {
            // adjust, option 皆沒修改
            this.chosen.adjust.push(this.adjust[i].adjust_id + '/')
          } else {
            for (var k = 0; k < oList.length; k++) {
              // console.log(oList[k])
              // console.log(oldOList[k])
              if (oList[k].price !== oldOList[k].price) {
                // option 有修改價格
                this.chosen.option.push(oList[k].option_id + '/' + oList[k].price)
              } else {
                // option 無修改價格
                this.chosen.option.push(oList[k].option_id + '/')
              }
            }
          }
        }
      }
      for (var m = 0; m < this.option.length; m++) {
        if (this.option[m].price !== this.oldOption[m].price) {
          // option 有修改
          this.chosen.option.push(this.option[m].option_id + '/' + this.option[m].price)
        } else {
          this.chosen.option.push(this.option[m].option_id + '/')
        }
      }
      // console.log(this.chosen)
      this.updateCombine()
    },
    updateCombine () {
      var self = this
      var url = 'brand/' + this.$route.params.brand_id + '/combination'
      var data = {
        combine_id: this.combineDetail.combine_id,
        adjust: this.chosen.adjust,
        option: this.chosen.option,
        product_id: this.productId,
        // return all
        name: this.combineDetail.name,
        price: this.combineDetail.price,
        price_type: this.combineDetail.price_type,
        is_common: this.combineDetail.is_common
      }
      // return all
      if (this.combineDetail.remark) data['remark'] = this.combineDetail.remark
      // console.log(this.combineDetail)
      // console.log(data)
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '提醒',
            text: '成功修改組合價格',
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.editState = false
          var id = self.modalId
          $('#' + id).modal('toggle')
        }
      })
    }
  },
  created () {
    this.init()
  },
  computed: {
    ...mapGetters(['getModal']),
    modalState () {
      if (this.state === 3 && !this.editState) return this.productName + '組合'
      if (this.editState) return '編輯' + '一般組合'
      else return '新增組合'
    },
    getDataH () {
      return this.$parent.getDataH
    },
    checkInput () {
      return this.$parent.checkInput
    },
    allInput () {
      return {
        name: this.checkInput(this.productInfo.name),
        sort: this.checkInput(this.productInfo.sort),
        vendor_custom_id: this.checkInput(this.productInfo.product_custom_id),
        description: this.checkInput(this.productInfo.description),
        remark: this.checkInput(this.productInfo.remark),
        price: this.checkInput(this.productInfo.price),
        calorie: this.checkInput(this.productInfo.calorie),
        min_limit: this.checkInput(this.productInfo.min_limit),
        max_limit: this.checkInput(this.productInfo.max_limit)
      }
    },
    pageAmount () {
      return Math.ceil(this.maxTotal / this.count)
    }
  },
  mounted () {
    var self = this
    $('.modal').on('hidden.bs.modal', function () {
      self.setModal(false)
      self.clearData()
    })
  },
  watch: {
    getModal () {
      if (this.getModal) {
        this.page = 1
        this.editState = false
        this.show.delNotify = false
        if (this.type === 'info') {
          this.getCombineInfo()
        }
      }
    }
  }
}
</script>
<style lang="sass">
  $default-color: #e1456d
  $light-gray: rgb(238, 238, 238)
  .input-option
    max-width: calc(100% - 15px)
</style>
<style lang="sass" scoped>
  .block-adjust-title
    margin-bottom: 10px
  .text-16.btn-options
    padding: 6px !important
  .icon-modal-edit.inherit, .icon-modal-del.inherit
    position: relative
    top: inherit
    right: inherit
  .icon-modal-edit.inherit
    margin-left: 10px
</style>



// WEBPACK FOOTER //
// CombinePriceModal.vue?3e86f63a